<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <div class="modal-header">
        <h5 class="modal-header-title">What's new</h5>
        <main-button class="back-btn" flat text="SKIP" @click="$emit('closeModal')" />
      </div>
      <div class="modal-main-container">
        <onboarding-modal-info
          :key="onboardingScreensInfo[focusedScreenIndex].id"
          :onboarding-info="onboardingScreensInfo[focusedScreenIndex]"
        />
      </div>
      <div class="buttons">
        <div class="back-btn-container">
          <main-button
            v-if="focusedScreenIndex > 0"
            class="back-btn"
            flat
            @click="previousScreen()"
          >
            <v-icon medium class="back-icon" color="#0277BD"> arrow_back </v-icon>
          </main-button>
          <div v-else />
        </div>
        <div class="screen-number-container">
          <div class="screen-number-text">{{ focusedScreenIndex + 1 }}/{{ totalScreensCount }}</div>
        </div>
        <div class="continue-btn-container">
          <main-button
            v-if="focusedScreenIndex === totalScreensCount - 1"
            class="continue-btn"
            text="done"
            depressed
            @click="$emit('closeModal')"
          />
          <main-button v-else class="continue-btn" depressed outline @click="nextScreen()">
            <span>NEXT</span>
            <v-icon class="arrow">arrow_forward</v-icon>
          </main-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { frontendURL } from '../../../utils'

import onboardingModalInfo from './onboarding-modal-info.vue'

export default {
  name: 'onboarding-modal',
  components: { onboardingModalInfo },
  data() {
    const onboardingScreensInfo = [
      {
        id: 1,
        imageUrl: `${frontendURL}/assets/onboarding/organizations.png`,
        title: 'Organizations',
        description:
          'We’re introducing Organizations! This allows you to group your events and manage them even more easily than before.',
      },
      {
        id: 2,
        imageUrl: `${frontendURL}/assets/onboarding/organization-info.png`,
        title: 'Add Organization Info',
        description:
          'Add your organization and financial info and it will apply to all your events under your Organization.',
      },
      {
        id: 3,
        imageUrl: `${frontendURL}/assets/onboarding/users.png`,
        title: 'Users and Event workers',
        description:
          'We’re introducing new user roles which will help streamline your event management.',
      },
      {
        id: 4,
        imageUrl: `${frontendURL}/assets/onboarding/whats-new.png`,
        title: "“What's new?”",
        description:
          'To revisit these tips and check new ones, simply click on the icon next to your user profile.',
      },
    ]

    return {
      onboardingScreensInfo,
      focusedScreenIndex: 0,
      totalScreensCount: onboardingScreensInfo.length,
    }
  },
  methods: {
    nextScreen() {
      this.focusedScreenIndex += 1
    },
    previousScreen() {
      this.focusedScreenIndex -= 1
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  height: fit-content;
  min-height: 39rem;
  max-height: 50%;
  width: 100%;
  position: relative;
  max-width: 42.75rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  z-index: 1;
  display: flex;
  flex-direction: column;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 1.5rem;
}
.modal-header-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}
.modal-main-container {
  padding: 0.5rem 3.5rem;
  flex: 1;
}
.modal-subtitle {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
.finance-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #979797;
}
.buttons {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 1.5rem;
}
.back-btn-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.continue-btn-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.screen-number-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.screen-number-text {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #666666;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }
}
</style>
